import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const FeatureFlags = () => {
  return (
    <>
      <Helmet>
        <title>Feature Flags - AutoScript Admin</title>
      </Helmet>
      <Content />
    </>
  );
};
